import { el, setAttr } from 'redom';

class NumberInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-number-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('input', {
      type: 'number',
      disabled: true
    });

    return this.input;

  }

  update(options) {

    const attributes = {
      placeholder: options.placeholder || ''
    };

    if (options.min !== undefined) {
      attributes.min = options.min;
    }

    if (options.max !== undefined) {
      attributes.max = options.max;
    }

    setAttr(this.input, attributes);

  }

}

export default NumberInputRenderer;
